import { c as _c } from "react/compiler-runtime";
import { HEADER_BORDER_BOTTOM, OVERLAY_BORDER, ROW_BORDER_BOTTOM } from '../../constants/borderStyles';
import { DEFAULT_COL_WIDTH } from '../../constants/defaultColWidth';
import { EagColumn } from '../../types/EagColumn';
import { EagColumnState } from '../../types/EagColumnState';
import { RowData } from '../../types/RowData';
import { getValueFromRawCell } from '../../utils/getValueFromRawCell';
import { renderCell } from '../../utils/renderCell';
export type DragOverlayColumnProps = {
  column: EagColumn;
  columnState: EagColumnState;
  rows: RowData[];
};

/**
 * Renders a full-column preview (header + all visible body cells) inside
 * the dnd-kit DragOverlay. This gives the user a visual representation
 * of the entire column being moved, not just the header chip.
 */
export function DragOverlayColumn(props) {
  const $ = _c(13);
  const width = props.columnState.width ?? DEFAULT_COL_WIDTH;
  let t0;
  if ($[0] !== width) {
    t0 = {
      width,
      maxWidth: width,
      ...OVERLAY_BORDER
    };
    $[0] = width;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.column.headerName) {
    t1 = <div className="px-2 py-2 text-xs font-semibold text-gray-600 bg-gray-50 h-9 flex items-center truncate select-none" style={HEADER_BORDER_BOTTOM}>{props.column.headerName}</div>;
    $[2] = props.column.headerName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.column || $[5] !== props.rows) {
    let t3;
    if ($[7] !== props.column) {
      t3 = row => {
        const rawValue = row[props.column.field];
        const value = getValueFromRawCell(props.column, rawValue);
        return <div key={row.id} className="px-2 h-[42px] flex items-center overflow-hidden whitespace-nowrap text-ellipsis text-sm" style={ROW_BORDER_BOTTOM}>{renderCell(props.column, value, row)}</div>;
      };
      $[7] = props.column;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = props.rows.map(t3);
    $[4] = props.column;
    $[5] = props.rows;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <div className="bg-white shadow-lg rounded overflow-hidden pointer-events-none" style={t0}>{t1}{t2}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}